import { requestAPIGateway } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

export const getRiskPolicies = async country => (await requestAPIGateway.get(`${country}/risk-policies`, getOptions())).data;

export const updateRiskPolicy = async (country, riskPolicyId, updateObj) => (await requestAPIGateway.patch(`${country}/risk-policies/${riskPolicyId}`, updateObj, getOptions())).data;
